import { useState } from 'react';

import { IconExternalLink } from '@spotify-internal/encore-web';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { isRenamableArtifact } from '../../artifactUtils';
import { ArtifactMenu } from '../ArtifactMenu';
import { RenameArtifactDialog } from './RenameArtifactDialog';

interface ArtifactActionsMenuProps {
  artifact: AttachmentFragment;
  displayName: string;
  resourcePath?: string;
  resolvedDisplayName?: string;
  navigateLabel?: string;
  onNavigateToResource?: () => void;
  onDelete?: () => void;
}

export const ArtifactActionsMenu = ({
  artifact,
  displayName,
  resourcePath,
  resolvedDisplayName,
  navigateLabel,
  onNavigateToResource,
  onDelete,
}: ArtifactActionsMenuProps) => {
  const [renameOpen, setRenameOpen] = useState(false);
  const renamable = isRenamableArtifact(artifact);
  const fullUrl = resourcePath
    ? `${window.location.origin}${resourcePath}`
    : undefined;

  return (
    <>
      <ArtifactMenu.Root
        aria-label="Artifact actions"
        copyUrl={fullUrl}
        displayName={displayName}
        onRename={renamable ? () => setRenameOpen(true) : undefined}
        onDelete={onDelete}
      >
        {onNavigateToResource && (
          <ArtifactMenu.Item
            icon={<IconExternalLink  data-track-source-anchor="1a496d454b;artifact-actions-menu-icon-external-link"/>}
            onClick={onNavigateToResource}
           data-track-source-anchor="d41023b409;artifact-actions-menu-item">
            {navigateLabel ?? 'Go to resource'}
          </ArtifactMenu.Item>
        )}
      </ArtifactMenu.Root>
      {renamable && (
        <RenameArtifactDialog
          artifact={artifact}
          resolvedDisplayName={resolvedDisplayName}
          open={renameOpen}
          onOpenChange={setRenameOpen}
         data-track-source-anchor="ea68881c62;artifact-actions-menu-rename-artifact-dialog"/>
      )}
    </>
  );
};
